module.exports = __webpack_public_path__ + "img/home_narrow_putaway_normal.9a71645d.svg";